/**
 * Agora 事件总线
 *
 * 职责：
 * 1. 提供 Agora RTC 事件的发布/订阅机制
 * 2. 解耦 AgoraRTCManager 和 UI 组件
 * 3. 支持多个组件订阅同一事件
 */

import mitt from 'mitt'

/**
 * Agora 事件类型常量
 */
export const AGORA_EVENTS = {
  // 用户加入频道
  USER_JOINED: 'user-joined',

  // 用户离开频道
  USER_LEFT: 'user-left',

  // 连接状态变化
  CONNECTION_STATE_CHANGE: 'connection-state-change',

  // Token 即将过期
  TOKEN_PRIVILEGE_WILL_EXPIRE: 'token-privilege-will-expire',

  // Token 已过期
  TOKEN_PRIVILEGE_DID_EXPIRE: 'token-privilege-did-expire',

  // ===== 状态机版本新增事件 =====
  // 远程用户状态变化（统一的状态更新事件）
  USER_STATE_CHANGED: 'user-state-changed',

  // Track 级别事件
  // Track 首帧解码完成
  TRACK_FIRST_FRAME_DECODED: 'track-first-frame-decoded',
  // Track 视频可见性变化
  TRACK_VIDEO_VISIBLE: 'track-video-visible',
  // Track 结束（用户关闭摄像头/麦克风）
  TRACK_ENDED: 'track-ended',
  // Track 静音状态变化
  TRACK_MUTE_STATE_CHANGED: 'track-mute-state-changed',

  // 本地视频状态变化（开启/关闭）
  LOCAL_VIDEO_STATE_CHANGED: 'local-video-state-changed',
}

/**
 * 创建 Agora 事件总线实例
 */
const agoraEventBus = mitt()

export default agoraEventBus
